var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import throttle from 'lodash/throttle';
import { scribeSetFontSize } from '../config';
import { UserError } from '../../errors';
import { authInstance, getFirestore } from '../../firebase';
import { users } from '../../services/api/ava';
export const firebaseLoginSuccess = (user, isNew) => {
    return {
        type: 'FIREBASE_USER_LOGIN_SUCCESS',
        user,
        isNew,
    };
};
export const firebaseLogout = () => ({
    type: 'FIREBASE_USER_LOGOUT',
});
export const updateScribeRemainingTime = (scribeRemainingTimeMs) => ({
    type: 'UPDATE_SCRIBE_REMAINING_TIME',
    scribeRemainingTimeMs,
});
export const updatePaidASRCreditTime = (paidASRCreditTime) => ({
    type: 'UPDATE_PAID_ASR_CREDIT_TIME',
    paidASRCreditTime,
});
export const decreasePaidASRCreditTime = () => ({
    type: 'DECREASE_PAID_ASR_CREDIT_TIME',
});
export const decreaseScribeRemainingTime = () => ({
    type: 'DECREASE_SCRIBE_REMAINING_TIME',
});
export function fetchScribeSettings() {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const { scribeSession: { captioner: user }, } = getState();
        if (!(user === null || user === void 0 ? void 0 : user.avaId)) {
            throw new UserError('No "avaId" found in "user" object');
        }
        const docRef = (yield getFirestore()).collection('users').doc(user.avaId);
        const doc = yield docRef.get();
        const { settings } = doc.data();
        if (settings && settings.webFontSize) {
            dispatch(scribeSetFontSize(settings.webFontSize));
        }
    });
}
const updateFontSize = throttle((avaId, uid, fontSize) => users.updateSettings({
    avaId,
    firebaseAuthUID: uid,
    settings: {
        webFontSize: fontSize,
    },
}), 2000);
export const scribeSetFontSizeAndSave = (fontSize) => (dispatch, getState) => {
    const { scribeSession: { captioner: user }, } = getState();
    updateFontSize(user.avaId, authInstance.currentUser.uid, fontSize);
    return dispatch(scribeSetFontSize(fontSize));
};
